import styled from 'styled-components'
import React from 'react'
import bgAsset from './lhype-logo.svg'
import bgAsset2 from './bg-asset.svg'

const IntroCardStyled = styled.div`
  border-radius: 14px;
  background: rgb(10, 36, 32);
  padding: 32px;
  font-family: Unbounded;
  position: relative;
  overflow: hidden;
  box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.01), 0px 4px 8px rgba(0, 0, 0, 0.04), 0px 16px 24px rgba(0, 0, 0, 0.04),
    0px 24px 32px rgba(0, 0, 0, 0.01);

  h1 {
    margin-top: 16px;
    margin-bottom: 8px;
    font-weight: 700;
    font-size: 20px;
    color: #fff;
  }
  p {
    font-weight: 400;
    font-size: 12px;
    margin-top: 0;
    margin-bottom: 0;
    color: #fff;

    svg {
      color: white;
    }
  }
  ${({ theme }) => theme.mediaWidth.upToSmall`
    padding: 16px;
    h1 {
      font-size: 16px;
    }
    p {
      font-size: 10px;
    }
`};
`
const BackgroundStyled = styled.div`
  z-index: 0;

  &:before {
    z-index: 2;
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background-image: url(${bgAsset});
    background-position: center;
    background-repeat: no-repeat;
    background-size: 130px;
    background-position: 96% 50%;
    opacity: 0.9;
    ${({ theme }) => theme.mediaWidth.upToSmall`
      opacity: 0.4;
      background-size: 90px;
  `};
  }

  &:after {
    z-index: 1;
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background-image: url(${bgAsset2});
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100%;
    opacity: 0.3;
  }
`
const ChildrenStyled = styled.div`
  z-index: 10;
  position: relative;
`

interface IntroCardI {
  children: any
}
const LoopedhypeIntroCard: React.FC<IntroCardI> = ({ children }) => {
  return (
    <IntroCardStyled>
      <ChildrenStyled>{children}</ChildrenStyled>
      <BackgroundStyled />
    </IntroCardStyled>
  )
}
export default LoopedhypeIntroCard
